import React from 'react'
import DashboardGraph from './DashboardGraph'
import Attendance from './Attendance'
import axios from "axios";
import { useQuery } from "react-query";
import { url, localUrl } from "./../../BaseUrl";
function AttendanceTracking({attendance}) {
  const { isLoading, error, data } = useQuery("getAttendance", async () => {
    const token = sessionStorage.getItem("token");

    const response = await axios.get(
      `${url}/api/auth/getAttendance`, // Ensure the correct endpoint
      {
        headers: {
          Authorization: `Bearer ${token}`, // Send token in the Authorization header
          "Content-Type": "application/json",
        },
      }
    );

    return response.data; // Return the fetched data
  });

  return (
    <div>
      <DashboardGraph graph={data}/>
      <Attendance records={data}/> 
    </div>
  )
}

export default AttendanceTracking
